import { render, staticRenderFns } from "./StaffSelection.vue?vue&type=template&id=435e15ae&scoped=true"
import script from "./StaffSelection.vue?vue&type=script&lang=js"
export * from "./StaffSelection.vue?vue&type=script&lang=js"
import style0 from "./StaffSelection.vue?vue&type=style&index=0&id=435e15ae&prod&lang=scss&scoped=true"
import style1 from "./StaffSelection.vue?vue&type=style&index=1&id=435e15ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435e15ae",
  null
  
)

export default component.exports